import React, { useEffect } from 'react'
import { AppRouteURI, AppRoutingRoles } from 'router/RoleBasedAccess'
import App from '../../components/app/App'
import SettingsContainer from './SettingsContainer'
import { ProfileContainer } from './Container'
import settingsActions from './actions'
import { SettingsTabs } from './constants'

export default function () {
    const { isProtected, checkRoles } = {
        ...AppRoutingRoles[AppRouteURI.SETTINGS],
    }
    const { setTab } = settingsActions()

    useEffect(() => {
        setTab(SettingsTabs.PROFILE)
    })
    return (
        <App isProtected={isProtected} checkRoles={checkRoles}>
            <ProfileContainer />
        </App>
    )
}
